import React, { useId } from 'react';
import { Box, BoxProps, Label, Text } from 'theme-ui';
import ErrorMessage from './ErrorMessage';
import Instruction from './Instruction';

type InstructionPlacement = 'above'|'below';

function RequiredIndicator({ required }) {
  return required
    ? <Text
        ml={1}
        sx={{
          color: 'red'
        }}
      >
        *
      </Text>
    : null
}
export interface FieldProps extends BoxProps {
  component: React.ReactElement;
  label?: React.ReactNode;
  error?: any;
  required?: boolean;
  instruction?: React.ReactNode;
  instructionPlacement?: InstructionPlacement;
  width?: any
}

export default function Field(
  {
    component,
    label,
    error,
    instruction,
    required,
    mb = 3,
    width,
    sx = {},
    instructionPlacement = 'below',
    ...rest
  }: FieldProps
) {

  const componentId = component.props.id || useId();

  const enhancedComponent = (componentId !== component.props.id) || error
    ? React.cloneElement(component, {
        id: componentId,
        ...(error && {
          sx: {
            backgroundColor: '#ffeded',
            position: 'relative',
            animation: 'shake .1s linear',
            animationIterationCount: 3,
            border: '2px solid red',
            outline: 'none',
          }
        })
      })
    : component;

  return (
    <Box
      mb={mb}
      sx={{
        width,
        ...sx,
      }}
      {...rest}
    >
      {label &&
        <Label
          htmlFor={componentId}
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {label}<RequiredIndicator required={required} />
        </Label>
      }
      {instruction && instructionPlacement == 'above' &&
        <Instruction>
          {instruction}
        </Instruction>
      }
      {enhancedComponent}
      <ErrorMessage
        message={error}
      />
      {instruction && instructionPlacement == 'below' &&
        <Instruction>
          {instruction}
        </Instruction>
      }
    </Box>
  )
}
